import React, { memo, useRef } from 'react';
import { Breakpoints } from '../../types/Breakpoints';
import { isMainNavigationBlock, MainNavigationBlock } from '../../_blocks/MainNavigation';
import { GlobalMenu, useGlobalMenu } from '../../contexts/GlobalMenuStore';
import { GlobalDocumentIds } from '../../types/GlobalDocumentIds';
import { useAppContext } from '../../contexts/AppContext/AppContext';

export type NavigationSection = {
  blocks: [MainNavigationBlock];
  uuid: string;
};

export const NavigationSection = memo(
  function ({ blocks }: NavigationSection) {
    NavigationSection.displayName = 'NavigationSection';
    const { windowInnerWidth } = useAppContext();
    const { currentOpenMenu } = useGlobalMenu();
    const mainNavigationBlock = blocks.find(isMainNavigationBlock);
    const navigationRef = useRef<HTMLDivElement>(null);

    const isExpanded = windowInnerWidth < Breakpoints.l_screen ? currentOpenMenu === GlobalMenu.MAIN_NAVIGATION : false;

    return (
      <div
        id={GlobalDocumentIds.mainNavigationBox}
        ref={navigationRef}
        className={
          isExpanded ? 'wrapper__main-navigation wrapper__main-navigation--expanded' : 'wrapper__main-navigation'
        }
      >
        {mainNavigationBlock && <MainNavigationBlock {...mainNavigationBlock} />}
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.uuid === nextProps.uuid
);
